import { GoogleAdsIcon } from './GoogleAdsIcon';

/**
 * author: Google
 * id 300B71B3-499A-4998-BA9D-22F2190229AA
 * name google-ads
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-ads.svg
 * tags
 * - Brand / Logo 
 */
export const GoogleAdwordsIcon = GoogleAdsIcon;
export default GoogleAdwordsIcon